import cn from 'classnames'
import { FC, useContext } from 'react'

import { Button } from 'core-components/library/button'
import { DatePicker } from 'core-components/library/datepicker'
import { LoaderOverlay } from 'core-components/library/loader'
import { APLTranslationCodes } from 'onboarding/configs/translations/aplTranslationCodes'
import { LanguageContext } from 'onboarding/context/LanguageContext'

import { DocumentField } from './components/documentField'
import { DOCUMENT_LANGUAGES, START_FROM_TODAY } from './configs'
import { useDocumentsForm } from './hooks/useDocumentsForm'

import styles from './UploadForm.module.scss'

interface IUploadFormProps {
  lastUploadDate: Date
  onSubmitFinish: () => void
}

export const UploadForm: FC<IUploadFormProps> = ({ lastUploadDate, onSubmitFinish }) => {
  const { t } = useContext(LanguageContext)

  const {
    documentsDate,
    handleSubmit,
    handleDocumentChange,
    changeDocumentsDate,
    isLoading,
    tncUploadResults,
    sdcUploadResults,
  } = useDocumentsForm({ initialDate: lastUploadDate, onSubmitFinish })

  return (
    <div className={styles.root}>
      <LoaderOverlay show={isLoading} />

      <div className={styles.fields}>
        <div className={styles.datepickerContainer}>
          <DatePicker
            fromDate={lastUploadDate}
            toDate={START_FROM_TODAY}
            value={documentsDate}
            mode="single"
            onChange={changeDocumentsDate}
          />
        </div>

        <div className={styles.labels}>
          <div className={cn(styles.column, styles.placeholder)} />
          <div className={cn(styles.column, styles.label)}>
            <h3>{t(APLTranslationCodes.documents_upload_form_terms_and_condition_title)}</h3>
          </div>
          <div className={cn(styles.column, styles.label)}>
            <h3>
              {t(APLTranslationCodes.documents_upload_form_selective_distribution_criteria_title)}
            </h3>
          </div>
        </div>
        {DOCUMENT_LANGUAGES.map((it) => (
          <DocumentField
            tncUploadResult={tncUploadResults[it.language]}
            sdcUploadResult={sdcUploadResults[it.language]}
            key={it.language}
            label={it.label}
            language={it.language}
            onDocumentFileChange={handleDocumentChange}
          />
        ))}

        <div className={styles.controls}>
          <Button onClick={handleSubmit} disabled={isLoading}>
            {t(APLTranslationCodes.documents_upload_form_submit)}
          </Button>
        </div>
      </div>
    </div>
  )
}
